import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { ClaimDocumentService } from 'src/app/core/services/claim_document.service';
import { KycService } from 'src/app/core/services/kyc.service';
import { PersonalDocumentService } from 'src/app/core/services/personal_document.service';
import { UserService } from 'src/app/core/services/user.service';
import { ClaimsService } from 'src/app/core/services/claims.service';
import { BaseKycProviderComponent } from '../base-kyc-provider.component';
import { DocumentTypeEnum } from '../document-kyc-upload-modal.component';
import { KycDataService } from 'src/app/modules/client/pages/guide/services/kyc-data.service';
import { ActionPollingService } from 'src/app/modules/client/pages/guide/services/action-polling.service';
import { KycFileValidationService } from '../services/kyc-file-validation.service';
import { KycMessageService } from '../services/kyc-message.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-veriff-lite-kyc-provider',
  templateUrl: '../base-kyc-provider.component.html',
  styleUrls: ['../base-kyc-provider.component.scss'],
})
export class VeriffLiteKycProviderComponent extends BaseKycProviderComponent {
  override options = [
    // { value: DocumentTypeEnum.PASSPORT, label: 'Passport' },
    { value: DocumentTypeEnum.ID_CARD, label: 'ID Card' },
    // Temporariamente desabilitado - não mostrar estas opções no Veriff
    // { value: DocumentTypeEnum.RESIDENCE_PERMIT, label: 'Residence Permit' },
    { value: DocumentTypeEnum.DRIVERS_LICENSE, label: 'Drivers License' },
    // Temporariamente desabilitado - não mostrar estas opções no Veriff
    // { value: DocumentTypeEnum.UNKNOWN, label: 'Other Document' },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) data: any,
    dialog: MatDialog,
    pds: PersonalDocumentService,
    cds: ClaimDocumentService,
    ks: KycService,
    us: UserService,
    dialogRef: MatDialogRef<VeriffLiteKycProviderComponent>,
    kycService: KycDataService,
    validationService: KycFileValidationService,
    messageService: KycMessageService,
    translate: TranslateService,
    claimsService: ClaimsService,
    actionPollingService: ActionPollingService,
    router: Router,
    activatedRoute: ActivatedRoute
  ) {
    const serviceData = kycService.getData();
    if (serviceData != null) {
      data = serviceData;
    }

    super(
      data,
      dialog,
      pds,
      cds,
      ks,
      us,
      dialogRef,
      kycService,
      validationService,
      messageService,
      translate,
      claimsService,
      actionPollingService,
      router,
      activatedRoute
    );
    if (!data.provider) data.provider = 'verifflite';
    
    console.log('[VERIFF LITE] Component initialized with options:', this.options);
    console.log('[VERIFF LITE] DRIVERS_LICENSE value:', DocumentTypeEnum.DRIVERS_LICENSE);
    console.log('[VERIFF LITE] DRIVER_LICENSE value:', DocumentTypeEnum.DRIVER_LICENSE);
  }
}
